import { FileEntity } from 'api/types/entity';

export interface LocalFileEntity extends Omit<FileEntity, 'id'> {
  id?: string;
}

export interface DocumentItemType extends LocalFileEntity {
  number: number;
  loading?: boolean;
}

export enum DocumentOptionType {
  download,
  delete,
}

export interface DocumentColumnArgs {
  editable?: boolean;
  canDeleteAnyDocument?: boolean;
  onClickOption: (item: DocumentItemType, option: DocumentOptionType) => void;
  onClickName?: (item: DocumentItemType) => void;
}
